"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var domElementPropType = function domElementPropType(props, propName, componentName) {
  var value = props[propName];
  if (value == null || typeof value === 'object' && value.nodeType === 1) return null;
  return new Error(componentName + ": Invalid " + propName + " value. Expected a DOM element.");
};

var _default = (0, _createChainablePropType.default)(domElementPropType, 'DOM element');

exports.default = _default;
module.exports = exports.default;